module.exports = __webpack_public_path__ + "img/6-small.f38e02b7.png";